// extracted by mini-css-extract-plugin
export default {"details":"ProfileDetails_details__lb-Mq","content":"ProfileDetails_content__brg-4","disableButton":"ProfileDetails_disableButton__mgBQq"};